import React from "react";
import { FormHelperText } from "@chakra-ui/react";
import { renderInnerHtml } from "@/helpers/dom";

interface Props {
  error?: string;
}

export const FormFieldError = ({ error }: Props) => {
  if (!error) return null;

  return (
    <FormHelperText color="primary-light">
      {renderInnerHtml(error || "")}
    </FormHelperText>
  );
};
